import * as validator from "validator";

function signForm(element) {
  const emailElement = element.querySelector("input[type=text]");

  element.addEventListener("submit", (e) => {
    const emailValue = (emailElement.value + "").trim();

    if (!emailValue || !validator.isEmail(emailValue)) {
      element.classList.add("has-error");
      e.preventDefault();
    }
  });
}

export function initSignForms() {
  document.querySelectorAll(".sign-form").forEach((c) => {
    signForm(c);
  });
}